// Consistent formatting helpers
import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export const SEVERITY_META = {
  Informational: { label: 'Info', hex: '#64748B', tw: 'bg-slate-500 text-white' },
  Low: { label: 'Low', hex: '#3B82F6', tw: 'bg-blue-500 text-white' },
  Moderate: { label: 'Moderate', hex: '#F59E0B', tw: 'bg-amber-500 text-white' },
  High: { label: 'High', hex: '#F97316', tw: 'bg-orange-500 text-white' },
  Critical: { label: 'Critical', hex: '#EF4444', tw: 'bg-red-500 text-white' },
};

export const CATEGORY_META = {
  water_change: { label: 'Water change', hex: '#3B82F6' },
  terrain_disturbance: { label: 'Terrain disturbance', hex: '#F97316' },
  encroachment: { label: 'Encroachment', hex: '#A855F7' },
  fire_flood: { label: 'Fire / Flood', hex: '#EF4444' },
  no_significant_change: { label: 'No change', hex: '#64748B' },
};

export const ZONE_META = {
  core: { label: 'Core', color: '#1FB6A6', dash: '0' },
  protection: { label: 'Protection', color: '#3B82F6', dash: '6 4' },
  catchment: { label: 'Catchment', color: '#22C55E', dash: '2 6' },
  downstream: { label: 'Downstream', color: '#F2B705', dash: '0' },
  access: { label: 'Access', color: '#64748B', dash: '10 6' },
  slope: { label: 'Slope', color: '#F97316', dash: '4 4' },
  restricted: { label: 'Restricted', color: '#EF4444', dash: '1 4' },
};

export function fmtDate(v) {
  if (!v) return '—';
  try {
    const d = typeof v === 'string' ? parseISO(v) : v;
    return format(d, 'yyyy-MM-dd HH:mm');
  } catch { return String(v).slice(0, 16); }
}

export function fmtRel(v) {
  if (!v) return '—';
  try {
    const d = typeof v === 'string' ? parseISO(v) : v;
    return `${formatDistanceToNowStrict(d)} ago`;
  } catch { return String(v).slice(0, 16); }
}

export function fmtCoord(v) {
  if (v === null || v === undefined) return '—';
  return Number(v).toFixed(5);
}

export function fmtPct(v, digits = 2) {
  if (v === null || v === undefined) return '—';
  return `${Number(v).toFixed(digits)}%`;
}

export function classNames(...xs) {
  return xs.filter(Boolean).join(' ');
}
